import { createContext, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewContext = /*#__PURE__*/createContext(null);
export function PreviewProvider({
  children
}) {
  const location = useLocation();

  // Snapshot the resolved location once on first render. Pages don't go in and
  // out of being preview.
  const snapshot = useRef(null);
  if (snapshot.current === null) {
    const params = new URLSearchParams(location.search);
    const isPreview = params.get('isPortalPreview') === 'true';
    const search = isPreview ? location.search : '';
    const hash = isPreview ? location.hash : '';
    snapshot.current = {
      isPreview,
      search,
      hash,
      suffix: `${search}${hash}`
    };
  }
  return /*#__PURE__*/_jsx(PreviewContext.Provider, {
    value: snapshot.current,
    children: children
  });
}
export function usePreviewContext() {
  const ctx = useContext(PreviewContext);
  if (ctx === null) {
    throw new Error('usePreviewContext must be used within a PreviewProvider');
  }
  return ctx;
}